import(/* webpackMode: "eager" */ "/vercel/path0/app/history/page.tsx");
